<div class="cell shrink sectionTitle-icon" [class.ghost]="isGhost">
    <i [ngClass]="faIconClass"  [class.ghost-remote-img]="isGhost"></i>
</div>
<div class="cell auto" [class.ghost]="isGhost">
    <div [class.xlarge-ghost-size]="isGhost">
        {{labelKey | translate}}
    </div>
    <ng-content></ng-content>
</div>
